export interface Labels {
  degreeLevel: string;
  type: string;
  value: string;
  apply: string;
  intake: string;
  nationality: string;
  viewDetail: string;
  deadline: string;
}

interface Intake {
  year: number;
}
interface CloseDate {
  id: number;
  month: string;
  day: number;
  year: number | null;
}

interface Organization {
  id: number;
  name: string;
  logo: string;
  country: number;
}
export interface ScholarshipData {
  id: number;
  organization: Organization;
  scholarship_name: string;
  scholarship_type: ScholarshipType[];
  scholarship_value: string;
  nationality: string;
  scholarship_eligibility: string;
  how_to_apply: string;
  scholarship_link: string;
  discipline: Discipline[];
  degree_level: DegreeLevel[];
  scholarship_courses: string;
  institute: Institute;
  scholarship_start_date: string[];
  close_date: CloseDate;
  slug: string;
  country: number | null;
  intakes: Intake[];
}
export interface DummyScholarshipData {
  scholarship_type: string;
  scholarship_value: string;
  degree_level: string;
  deadline: string;
  intakes: string;
  scholarship_name: string;
  logo: string;
  institute_name: string;
}

export interface ScholarshipType {
  id: number;
  display_name: string;
  slug: string;
}

interface Discipline {
  id: number;
  name: string;
  key: string;
  slug: string;
}

interface DegreeLevel {
  id: number;
  name: string;
  key: string;
  level_type: string;
  slug: string;
}

interface Institute {
  logo: string;
  id: number;
  institute_name: string | null;
  slug: string;
}

export interface CourseCard {
  labels: Labels;
  defaultImage: string;
  altImage: string;
  defaultFee: string;
  defaultDuration: string;
}

export const courseCardData: CourseCard = {
  defaultImage: "/images/university-logo-default.png",
  altImage: "Course Image",
  defaultFee: "To Be Confirmed",
  defaultDuration: "N/A",
  labels: {
    degreeLevel: "Degree Level",
    type: "Type",
    value: "Value",
    apply: "Apply now",
    intake: "Intake",
    deadline: "Deadline",
    nationality: "Nationality",
    viewDetail: "View detail",
  },
};

export const dummyData: DummyScholarshipData[] = [
  {
    institute_name: "Edith Cowan College, Australia",
    scholarship_name: "Chevening Scholarship",
    scholarship_type: "Academic",
    scholarship_value: "$3000",
    degree_level: "Bachelors",
    deadline: "12 October 2024",
    intakes: "2024,2025",
    logo: "",
  },
  {
    institute_name: "Edith Cowan College, Australia",
    scholarship_name: "Chevening Scholarship",
    scholarship_type: "Academic",
    scholarship_value: "$3000",
    degree_level: "Bachelors",
    deadline: "12 October 2024",
    intakes: "2024,2025",
    logo: "",
  },
];

export const sectionHeadingData = {
  title: "Scholarship programs in ",
  paragraph:
    "The UK is renowned for its world-class education, home to some of the most prestigious universities, including Oxford, Cambridge, and Imperial College London. With a strong emphasis on innovation and research, UK institutions offer cutting-edge programs across various disciplines, ensuring students receive top-quality education. Studying in the UK provides access to globally recognized degrees, which open doors to career opportunities worldwide.",
};
